/**
 * PATH: apps/inventory/src/pages/OrdersPage.tsx
 * PURPOSE: Purchase orders management
 */
import { EmptyRegister } from './emptyRegister'

export default function OrdersPage() {
  return (
    <EmptyRegister
      title="Purchase Orders"
      detail="No purchase orders are connected."
    />
  )
}
